<template>
  <RestyleModal @close="setIsVisibleModalReportWorkDrivers(false)" @cancel="setIsVisibleModalReportWorkDrivers(false)" @save="BTNDownload" :sendDisabled="isDisabledBtn">
    <template v-slot:header>
      Отчёт по работе водителей
    </template>
    <div>
      <div style="min-height: 350px">
        <div class="mb-4">
          <DateRangePicker @dateChange="changeFilter('dates', $event)" @dayclick="handleDayClick" :dates="currentDates" :dateSelectBoxStyle="dateSelectBoxStyle" :minDate="minDate" :maxDate="maxDate" :canClearDate="true" class="date-filter" />
        </div>
        <div class="mb-4">
          <SearchFilterMultiSelect :allSelectOptions="computedUserOrganisations" :inputText="searchUserOrganisation" @inputChange="searchUserOrganisation = $event" @selectedOptionsChange="selectedOptionsChange" :selectedOptions="selectedUserOrganisation" placeholder="Организации" :wordForms="['организация', 'организации', 'организаций']" :wordFormsSelected="['Выбрана', 'Выбрано', 'Выбрано']" class="text-left" style="width: 300px" />
        </div>
        <div class="mb-4">
          <!-- Водитель -->
          <SearchFilterMultiSelect
            v-if="selectedUserOrganisation.length"
            @inputChange="driverSearch = $event"
            @selectedOptionsChange="selectedDrivers = $event"
            :inputText="driverSearch"
            :selectedOptions="selectedDrivers"
            :allSelectOptions="drivers"
            :disabled="isDriverSelectDisabled"
            placeholder="Водители"
            :wordForms="['водитель', 'водителя', 'водителей']"
            :wordFormsSelected="['Выбран', 'Выбрано', 'Выбрано']"
            style="width: 300px;"
          >
            <template v-slot:option="slotProps">
              <span>{{ slotProps.option?.name }}</span>
            </template>
          </SearchFilterMultiSelect>
        </div>
        <div style="display: flex; align-items: center; cursor: pointer; margin-left: 10px;" @click.self="skipNavigation = !skipNavigation">
          <baseCheckbox style="margin-right: 10px" v-model="skipNavigation" />
          Без навигации
        </div>
      </div>
    </div>
    <template v-slot:confirmButtonText> Скачать </template>
  </RestyleModal>
</template>

<script>
import DateRangePicker from "@/components/restyle/calendar/DateRangePicker.vue";
import CheckboxSquareMultiselectFilter from '@/components/restyle/primitives/checkboxes/CheckboxSquareMultiselectFilter.vue';
import SearchFilterMultiSelect from "@/components/restyle/primitives/filters/SearchFilterMultiSelect.vue";
import { transformOrgsIntoOrgTree } from "@/_helpers/functions/functions";
import { mapGetters, mapMutations } from "vuex";
import { request } from "@/_helpers";
import baseCheckbox from "@/primitivesVue3/baseCheckbox/baseCheckbox.vue";
import SearchFilterSelect from "@/components/restyle/primitives/filters/SearchFilterSelect.vue";

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true,
  },
  components: {
    DateRangePicker,
    CheckboxSquareMultiselectFilter,
    SearchFilterMultiSelect,
    baseCheckbox,
    SearchFilterSelect
  },
  data() {
    return {
      dateSelectBoxStyle: { width: '270px', height: 'unset' },
      minDate: null,
      maxDate: null,
      currentDates: { start: null, end: null },
      firstClickedDate: null,
      searchUserOrganisation: "",
      selectedUserOrganisation: [],
      isDisabledBTN: false,
      skipNavigation: false,
      drivers: [],
      driverSearch: '',
      selectedDrivers: [],
    }
  },
  created() {
    const today = new Date();
    const formattedToday = this.formatDate(today);
    this.$set(this.currentDates, 'start', formattedToday);
    this.$set(this.currentDates, 'end', formattedToday);
    this.minDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 365);
    this.maxDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 365);
  },
  methods: {
    ...mapMutations({
      setIsWaitAlertAfterRequest: "user_notifications/SET_IS_WAIT_ALERT_AFTER_REQUEST",
      setIsVisibleModalReportWorkDrivers: "reports/set_is_visible_modal_report_work_drivers"
    }),
    formatDate(date) {
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');
      return `${dd}-${mm}-${yyyy}`;
    },
    handleDayClick(event) {
      if (!event.isDisabled) {
        const clickedDate = new Date(event.id);
        const formattedClickedDate = this.formatDate(clickedDate);
        if (!this.firstClickedDate) {
          this.firstClickedDate = clickedDate;
          this.currentDates = { start: formattedClickedDate, end: formattedClickedDate };
        } else {
          let start = this.firstClickedDate;
          let end = clickedDate;
          if (start > end) {
            [start, end] = [end, start];
          }
          const diffDays = (end - start) / (1000 * 60 * 60 * 24);
          if (diffDays <= 365) {
            this.currentDates = { start: this.formatDate(start), end: this.formatDate(end) };
          } else {
            alert('Период не должен превышать 1 год.');
          }
          this.firstClickedDate = null;
        }
      }
    },
    changeFilter(nameFilter, event) {
      if (nameFilter === 'dates') {
        this.currentDates = event;
        this.getDriverList();
      }
    },
    BTNDownload() {
      this.isDisabledBTN = true;
      const organisationIDS = this.selectedUserOrganisation.map(item => item.id);
      request(`${process.env.VUE_APP_WN}/fact/waybill/report`, "post", {
        begin_date: this.currentDates.start.split('-').reverse().join('-'),
        end_date: this.currentDates.end.split('-').reverse().join('-'),
        organisation_ids: organisationIDS,
        skip_navigation: this.skipNavigation,
        driver_ids: this.selectedDrivers.map((driver) => driver.id)
      })
        .then((response) => {
          if (response.success) {
            this.$store.dispatch('alert/alerts', { message: `${response.message}`, type: 'success' });
            this.setIsWaitAlertAfterRequest(true);
          }
        }).catch((error) => {
          this.$store.dispatch('alert/alerts', { message: `${error.message}`, type: 'danger' });
        }).finally(() => {
          this.isDisabledBTN = false;
          this.setIsWaitAlertAfterRequest(false);
        })
    },
    isSelected(option) {
      return this.selectedOptions.some(selectedOption => selectedOption.name === option.name && selectedOption.type === option.type);
    },
    chooseAll() {
      return this.filteredOptions.length > 0 && this.filteredOptions.every(option => this.isSelected(option));
    },
    toggleAllFilteredOptions() {
      if (this.chooseAll) {
        this.$emit('selectedOptionsChange', []);
      } else {
        this.$emit('selectedOptionsChange', this.filteredOptions);
      }
    },
    computedPlaceholder() {
      if (this.selectedOptions.length > 0) {
        return `${getWordForm(this.selectedOptions.length, this.wordFormsSelected)}`
          + ` ${this.selectedOptions.length} `
          + `${getWordForm(this.selectedOptions.length, this.wordForms)}`;
      } else {
        return this.placeholder;
      }
    },
    getDriverList() {
      const organisationIDS = this.selectedUserOrganisation.map(item => item.id);
      let query =
        `begin_date=${this.$moment(this.currentDates.start, 'DD-MM-YYYY').format('YYYY-MM-DD')}` +
        `&end_date=${this.$moment(this.currentDates.end, 'DD-MM-YYYY').format('YYYY-MM-DD')}`;
      if (organisationIDS.length) {
        organisationIDS.forEach(id => {
          query += `&organisation_ids[]=${id}`;
        });
      } else {
        query += `&organisation_id=${this.userOrganisations[0].id}`;
      }

      const url = `${process.env.VUE_APP_WN}/fact/waybill/driver_list?${query}`;

      request(url, "get")
        .then((res) => {
          this.drivers = res.data;
        });
    },
    selectedOptionsChange(event) {
      this.selectedUserOrganisation = event;
      this.getDriverList();
    }
  },
  computed: {
    ...mapGetters({
      userOrganisations: 'user/userOrganisations',
    }),
    isDisabledBtn() {
      return !this.selectedUserOrganisation.length || !this.currentDates?.start || !this.currentDates?.end || this.isDisabledBTN;
    },
    computedUserOrganisations() {
      let result = transformOrgsIntoOrgTree(this.userOrganisations)
      result = result.reduce((acc, item) => {
        acc.push(item)

        if (item.children?.length > 0) {
          for (const iterator of item.children) {
            acc.push({ ...iterator, itsChild: true })
          }
        }

        return acc
      }, [])

      return result
    },
    isDriverSelectDisabled() {
      return !this.currentDates?.start || !this.currentDates?.end || !this.selectedUserOrganisation.length;
    },
  }
};
</script>

<style lang="scss" scoped></style>

<style lang="scss">
.date-filter {
  & .date-value {
    color: $color-button-text !important;
  }
}
</style>